// Generated from the GraphQL schema. Do not edit manually.

export type FieldKind = 'string' | 'int' | 'float' | 'boolean' | 'datetime' | 'list' | 'object'

export const MODEL_FIELD_TYPES: Record<string, Record<string, FieldKind>> = {
  Action: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    actionId: 'string',
    orgId: 'string',
    workspaceId: 'string',
    contactId: 'string',
    queueName: 'string',
    queueId: 'string',
    state: 'string',
    untilDate: 'datetime',
    note: 'string',
    userId: 'string',
  },
  ActionListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ActivateAccountResult: {
    email: 'string',
    code: 'string',
    allowGoogle: 'boolean',
    name: 'string',
    phone: 'string',
    position: 'string',
  },
  Activity: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    archived: 'boolean',
    contacts: 'list',
    contactCount: 'int',
    type: 'string',
    typeId: 'string',
    subType: 'string',
    description: 'string',
    note: 'string',
    activityDate: 'datetime',
    needsReview: 'boolean',
    reviewReason: 'string',
    matchTypes: 'list',
    contactName: 'string',
    contactPhone: 'string',
    nameFromActivity: 'string',
    nameSource: 'string',
    phoneFromActivity: 'string',
    source: 'string',
    utmSource: 'string',
    utmMedium: 'string',
    utmCampaign: 'string',
    utmKeywords: 'string',
    utmContent: 'string',
    referringUrl: 'string',
    tags: 'list',
    owner: 'object',
    utmAccountId: 'string',
    utmCampaignId: 'string',
    trackableCampaignId: 'string',
    vendor: 'string',
    fbclid: 'string',
    gclid: 'string',
    data: 'string',
    email: 'string',
    channel: 'string',
    isQualified: 'boolean',
    smsMarketingOptIn: 'boolean',
    trackingNumber: 'string',
    trackingNumberName: 'string',
  },
  ActivityContact: {
    id: 'string',
    name: 'string',
    phone: 'string',
    matchDate: 'datetime',
    nameFromActivity: 'string',
    peopleIndex: 'int',
    lifecycleStage: 'string',
    locationId: 'string',
  },
  ActivityCountResult: {
    count: 'int',
  },
  ActivityListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ActivityOwner: {
    id: 'string',
    name: 'string',
    aliases: 'list',
    userId: 'string',
  },
  AdCampaign: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    type: 'string',
    platform: 'string',
    name: 'string',
    vendorCampaignId: 'string',
    accountId: 'string',
    accountName: 'string',
  },
  AdPlatformMapping: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    source: 'string',
    medium: 'string',
    platform: 'string',
  },
  AdPlatformMappingListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  AIAgentConfiguration: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    agentName: 'string',
    agentVoiceId: 'string',
    greeting: 'string',
    businessName: 'string',
    businessAddress: 'string',
    services: 'list',
    servicesNotOffered: 'list',
    offers: 'list',
    sayThisNotThatRules: 'list',
    emergencyApptId: 'string',
    generalApptId: 'string',
    smsConfirmationEnabled: 'boolean',
    postBookingMessage: 'string',
    hygienePostBookingMessage: 'string',
    consultApptId: 'string',
    limitedExamApptId: 'string',
    voiceAgentAddendum: 'string',
    cleaningRequiresInitialExam: 'boolean',
    pediatricOnly: 'boolean',
    voiceAgentTools: 'list',
    systemPrompt: 'string',
    model: 'string',
    temperature: 'float',
    tools: 'string',
    promptVersion: 'string',
    promptDeployedDate: 'datetime',
  },
  AIAgentConfigurationSnapshot: {
    insurances: 'string',
    services: 'string',
    businessHours: 'string',
    offers: 'string',
    acceptInsuranceStateHMO: 'boolean',
  },
  AIAgentNotificationSettings: {
    enabled: 'boolean',
    newAIAgentCall: 'object',
    emergencyAppointmentRequest: 'object',
    newAppointmentBooked: 'object',
  },
  AIAgentOffer: {
    name: 'string',
    patientStatus: 'string',
    eligibleInsurance: 'string',
    onlyEmergencyEligible: 'boolean',
  },
  AIAgentOverview: {
    id: 'string',
    locationId: 'string',
    agentName: 'string',
    greeting: 'string',
    businessName: 'string',
    businessAddress: 'string',
    postBookingMessage: 'string',
    hygienePostBookingMessage: 'string',
    smsConfirmationEnabled: 'boolean',
    generalApptId: 'string',
    emergencyApptId: 'string',
    consultApptId: 'string',
    limitedExamApptId: 'string',
    offers: 'list',
    services: 'list',
    servicesNotOffered: 'list',
    sayThisNotThatRules: 'list',
  },
  AIAgentService: {
    name: 'string',
    lowPrice: 'float',
    highPrice: 'float',
    consultRequired: 'boolean',
    consultPrice: 'float',
  },
  AIConversationMessage: {
    role: 'string',
    content: 'string',
  },
  AIConversationTurn: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    threadId: 'string',
    messageId: 'string',
    contactId: 'string',
    aiWorkflowId: 'string',
    aiAgentId: 'string',
    from: 'string',
    to: 'string',
    turnIndex: 'int',
    systemPrompt: 'string',
    conversationHistory: 'list',
    response: 'string',
    steps: 'list',
    agentConfiguration: 'object',
    model: 'string',
    temperature: 'float',
    tokenUsage: 'object',
    latencyMs: 'int',
    costUsd: 'float',
    smsCostUsd: 'float',
    isInitialMessage: 'boolean',
    activityId: 'string',
    failed: 'boolean',
    failureReason: 'string',
    failureMessage: 'string',
  },
  AIConversationTurnListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  AIConversationTurnStep: {
    toolCalls: 'list',
    toolResults: 'list',
    text: 'string',
  },
  AIConversationTurnToolCall: {
    toolName: 'string',
    args: 'string',
  },
  AIConversationTurnToolResult: {
    toolName: 'string',
    result: 'string',
    isError: 'boolean',
  },
  AIInputTokenDetails: {
    cacheReadTokens: 'int',
  },
  AITokenUsage: {
    inputTokens: 'int',
    outputTokens: 'int',
    totalTokens: 'int',
    cachedInputTokens: 'int',
    inputTokenDetails: 'object',
  },
  Appointment: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    locationId: 'string',
    patientId: 'string',
    providerId: 'string',
    sikkaPracticeId: 'string',
    sikkaOfficeId: 'string',
    amount: 'float',
    pmsStatus: 'string',
    status: 'string',
    confirmed: 'boolean',
    note: 'string',
    date: 'datetime',
    time: 'string',
    duration: 'string',
    description: 'string',
    appointmentMadeDate: 'datetime',
    type: 'string',
    procedureCodes: 'list',
    procedureCode1: 'string',
    procedureCode1Amount: 'string',
    procedureCode2: 'string',
    procedureCode2Amount: 'string',
    procedureCode3: 'string',
    procedureCode3Amount: 'string',
    procedureCode1Time: 'string',
    procedureCode2Time: 'string',
    procedureCode3Time: 'string',
    timeToAppointment: 'int',
    source: 'string',
  },
  AppointmentListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  AppointmentType: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    kollaConsumerId: 'string',
    name: 'string',
    vendorId: 'string',
    displayName: 'string',
    alias: 'string',
    patientType: 'string',
    procedureCodes: 'list',
    appointmentLength: 'float',
    startIncrement: 'float',
    blockScheduling: 'boolean',
    excludedBlockouts: 'list',
    blockSchedulingNotes: 'list',
    activeScheduler: 'boolean',
    activeAgent: 'boolean',
    order: 'float',
    doubleBookingExclusion: 'boolean',
    vendor: 'string',
    generalBuffer: 'float',
    morningBuffer: 'float',
    morningBufferLookahead: 'float',
  },
  AppointmentTypeListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  AscendLocation: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
  },
  AscendRequestResult: {
    success: 'boolean',
    error: 'string',
    data: 'string',
    responseTimeMs: 'int',
  },
  AssignedWorkspace: {
    id: 'string',
    roleId: 'string',
    locationIds: 'list',
  },
  AuthPayload: {
    accessToken: 'string',
    user: 'object',
  },
  Availability: {
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    kollaConsumerId: 'string',
    locationId: 'string',
    providerId: 'string',
    archived: 'boolean',
    backupAvailability: 'boolean',
    operatoryId: 'string',
    operatoryIds: 'list',
    appointmentTypeIds: 'list',
    timeSlots: 'object',
    createdDate: 'datetime',
    updatedDate: 'datetime',
  },
  AvailablePhoneNumber: {
    phone: 'string',
    type: 'string',
    locality: 'string',
  },
  BackgroundJobProgress: {
    id: 'string',
    jobId: 'string',
    type: 'string',
    description: 'string',
    locationId: 'string',
    orgId: 'string',
    totalTasks: 'int',
    remaining: 'int',
    completed: 'int',
    percentComplete: 'int',
    complete: 'boolean',
    createdAt: 'datetime',
    completedAt: 'datetime',
  },
  BackgroundJobProgressConnection: {
    nodes: 'list',
    pageInfo: 'object',
  },
  BlockoutNote: {
    note: 'string',
    startTime: 'string',
    endTime: 'string',
    appointmentType: 'string',
  },
  BudgetListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  BudgetMetricsResponse: {
    total: 'float',
  },
  BudgetResult: {
    id: 'string',
    locationId: 'string',
    yearMonth: 'string',
    channel: 'string',
    amount: 'float',
    targetSpend: 'float',
    internalGoal: 'float',
    leadGoal: 'int',
    patientGoal: 'int',
    mqlGoal: 'int',
    appointmentGoal: 'int',
  },
  Call: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    elevenLabsConversationId: 'string',
    archived: 'boolean',
    channel: 'string',
    vendor: 'string',
    answerer: 'string',
    answered: 'boolean',
    ai: 'object',
    treatment: 'string',
    patientNames: 'string',
    callerId: 'string',
    trackingNumber: 'string',
    trackingNumberName: 'string',
    tags: 'list',
    waveforms: 'list',
    appointmentDateString: 'string',
    callerPhone: 'string',
    businessPhone: 'string',
    callDate: 'datetime',
    note: 'string',
    status: 'string',
    recordingDuration: 'int',
    duration: 'int',
    utmSource: 'string',
    utmMedium: 'string',
    utmCampaign: 'string',
    utmKeywords: 'string',
    utmContent: 'string',
    referringUrl: 'string',
    gclid: 'string',
    landingPageUrl: 'string',
    recordings: 'list',
    patients: 'list',
    staff: 'object',
    aiAgent: 'boolean',
    golden: 'boolean',
    direction: 'string',
    people: 'list',
    allPatientOutcomes: 'list',
  },
  CallAi: {
    summary: 'string',
    actionItems: 'string',
    people: 'list',
    answerer: 'string',
    channel: 'string',
    extractionDate: 'string',
    model: 'string',
    tokenUsage: 'object',
  },
  CallData: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    callId: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    elevenLabsConversationId: 'string',
    callDate: 'datetime',
    duration: 'int',
    elevenLabsCost: 'object',
    twilioTelephonyCostUsd: 'float',
    extractedData: 'string',
    toolError: 'boolean',
    toolTimeout: 'boolean',
    toolDuplicate: 'boolean',
    terminationReason: 'string',
    errorCode: 'int',
    errorReason: 'string',
    callSuccessful: 'string',
    noBookingReason: 'string',
    archived: 'boolean',
    data: 'string',
  },
  CallDataListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  CallerIdResult: {
    callerId: 'string',
    customerName: 'string',
  },
  CallListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  CallPerson: {
    name: 'string',
    treatment: 'string',
    serviceRequested: 'string',
    relationship: 'string',
    appointmentDate: 'string',
    appointmentTime: 'string',
    phone: 'string',
    patientType: 'string',
    appointmentScheduled: 'boolean',
    appointmentRequested: 'boolean',
    birthDate: 'string',
    referral: 'string',
    insuranceProvider: 'string',
    outcomes: 'list',
    reasonForNotScheduling: 'string',
    isCaller: 'boolean',
    index: 'int',
    email: 'string',
  },
  CallRailCompany: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
  },
  CallRailRoutingConfig: {
    tag: 'string',
    locationId: 'string',
  },
  CallTokenUsage: {
    inputTokens: 'int',
    outputTokens: 'int',
    totalTokens: 'int',
  },
  CampaignItem: {
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    type: 'string',
    platform: 'string',
    name: 'string',
    vendorCampaignId: 'string',
    accountId: 'string',
    accountName: 'string',
  },
  CampaignListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  CarestackDashboardResult: {
    base64: 'string',
    workspaces: 'list',
  },
  CarestackPractice: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
  },
  CarestackWorkspaceStat: {
    workspaceId: 'string',
    workspaceName: 'string',
  },
  CdtCodeMapping: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    cdtCode: 'string',
    category: 'string',
  },
  CdtCodeMappingListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ChannelBreakdownEntry: {
    channel: 'string',
    leads: 'int',
    mqls: 'int',
    appointments: 'int',
    patients: 'int',
  },
  ChannelCount: {
    channel: 'string',
    count: 'int',
  },
  ChannelMappingV2: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    source: 'string',
    medium: 'string',
    channel: 'string',
  },
  ChannelMappingV2ListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  CommandResult: {
    success: 'boolean',
    error: 'string',
    synced: 'int',
  },
  CommLog: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    vendorId: 'string',
    patientId: 'string',
    pmsPatientId: 'string',
    mode: 'int',
    commType: 'int',
    sentOrReceived: 'int',
    note: 'string',
    userNum: 'int',
    commSource: 'int',
    programNum: 'int',
    channel: 'string',
    provider: 'string',
    subject: 'string',
    sourceId: 'string',
    commDate: 'datetime',
    commEndDate: 'datetime',
    pmsUpdatedDate: 'datetime',
  },
  CommLogListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  CommLogWritebackRule: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    type: 'string',
    channel: 'string',
  },
  CommLogWritebackRuleListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Contact: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    patientIds: 'list',
    patientName: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    name: 'string',
    preferredName: 'string',
    homePhone: 'string',
    cellPhone: 'string',
    workPhone: 'string',
    otherPhone: 'list',
    email: 'string',
    birthDate: 'datetime',
    addressLine1: 'string',
    addressLine2: 'string',
    lifecycleStage: 'string',
    patientStatus: 'string',
    leadStatus: 'string',
    isQualified: 'boolean',
    appointmentStatus: 'string',
    nearestAppointmentDate: 'datetime',
    city: 'string',
    state: 'string',
    zip: 'string',
    becameLeadDate: 'datetime',
    becamePatientDate: 'datetime',
    patientCreatedDate: 'datetime',
    firstAppointmentMadeDate: 'datetime',
    firstAppointmentDate: 'datetime',
    lastAppointmentDate: 'datetime',
    firstTransactionDate: 'datetime',
    lastTransactionDate: 'datetime',
    lastHygieneDate: 'datetime',
    hygieneDueDate: 'datetime',
    isPerio: 'boolean',
    hygieneStatus: 'string',
    tags: 'list',
    matchTypes: 'list',
    collectedLtv: 'float',
    productionLtv: 'float',
    scheduledProduction: 'float',
    unbookedTreatmentValue: 'float',
    lastTreatmentPlanDate: 'datetime',
    treatmentStatus: 'string',
    fvv: 'float',
    fbclid: 'string',
    adClickDate: 'datetime',
    referralURL: 'string',
    patientReferral: 'string',
    lastActivityDate: 'datetime',
    lastCommDate: 'datetime',
    lastCommActivityType: 'string',
    lastCommActivitySubType: 'string',
    utmSource: 'string',
    utmMedium: 'string',
    utmCampaign: 'string',
    utmKeywords: 'string',
    utmContent: 'string',
    gclid: 'string',
    platform: 'string',
    trackableCampaignId: 'string',
    leadOwner: 'object',
    channel: 'string',
    smsMarketingConsent: 'boolean',
    firstContactReason: 'string',
    firstActivityType: 'string',
    activityTypes: 'list',
    convertedBy: 'object',
    firstActivityDate: 'datetime',
    becameInactiveDate: 'datetime',
    closedLostReason: 'string',
    preferredCommunicationMethod: 'string',
    preferredContact: 'string',
    archived: 'boolean',
    pipelines: 'list',
    neededAction: 'boolean',
    reportedAttribution: 'string',
    activityCount: 'int',
    landingPageURL: 'string',
    needsActionDate: 'datetime',
    leadConversionStatus: 'string',
    firstName: 'string',
    lastName: 'string',
  },
  ContactListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ContactPipeline: {
    id: 'string',
    stage: 'string',
    key: 'string',
  },
  ConversionLogItem: {
    id: 'string',
    contactId: 'string',
    locationId: 'string',
    contactName: 'string',
    becameLeadDate: 'string',
    firstAppointmentMadeDate: 'string',
    becamePatientDate: 'string',
    conversionType: 'string',
    status: 'string',
    gclid: 'string',
    conversionDateTime: 'string',
    createdDate: 'string',
    conversionValue: 'float',
    errorMessage: 'string',
    googleAdsAccountId: 'string',
  },
  ConversionLogListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ConversionMetricsResponse: {
    QUALIFIED_LEAD_GENERATED: 'object',
    NEW_PATIENT_APPOINTMENT_SCHEDULED: 'object',
    NEW_PATIENT_GENERATED: 'object',
    ADDITIONAL_TREATMENT_REVENUE: 'object',
    total: 'int',
  },
  ConversionStageMetrics: {
    total: 'int',
    failed: 'int',
  },
  CustomPage: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    userId: 'string',
    name: 'string',
    page: 'string',
    join: 'string',
    filters: 'list',
  },
  CustomPageFilter: {
    attribute: 'string',
    secondaryAttribute: 'string',
    displayName: 'string',
    operator: 'string',
    value: 'string',
    secondaryValue: 'list',
    static: 'boolean',
    uniqOperator: 'string',
    readOnly: 'boolean',
    nonEmpty: 'boolean',
    useAsterisk: 'boolean',
    group: 'string',
    subQuery: 'string',
    type: 'string',
    defaultValue: 'string',
    dateOperator: 'string',
    includeToday: 'boolean',
    includeYesterday: 'boolean',
    includeWeeks: 'boolean',
    limitToMonth: 'boolean',
    includeInThePast: 'boolean',
    options: 'string',
  },
  CustomPageListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  CustomQuestion: {
    id: 'string',
    fieldName: 'string',
    required: 'boolean',
    fieldType: 'string',
    enabled: 'boolean',
    description: 'string',
    marketingConsent: 'boolean',
    optIn: 'boolean',
  },
  DataCompareResult: {
    success: 'boolean',
    message: 'string',
    sourceRecord: 'string',
    targetRecord: 'string',
    match: 'boolean',
  },
  DNI: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    label: 'string',
    forwardTo: 'string',
    poolSize: 'int',
    sessionDuration: 'int',
    areaCode: 'string',
    maxPoolSize: 'int',
    minFree: 'int',
    buyStep: 'int',
    minPoolSize: 'int',
    ivrConfigId: 'string',
    phoneNumberIds: 'list',
    enabled: 'boolean',
  },
  DNIListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ElevenLabsAgent: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
  },
  ElevenLabsCostSummary: {
    total: 'float',
    llm: 'float',
    tts: 'float',
    asr: 'float',
    platform: 'float',
    llmInputTokens: 'int',
    llmOutputTokens: 'int',
  },
  ElevenLabsDeployment: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    promptId: 'string',
    promptKey: 'string',
    promptName: 'string',
    category: 'string',
    promptRevision: 'int',
    model: 'string',
    temperature: 'float',
    sourceVersionId: 'string',
    sourceDraftId: 'string',
    sourceBody: 'string',
    deployedBy: 'string',
    requestedAt: 'datetime',
    deployedAt: 'datetime',
    status: 'string',
    note: 'string',
    targetScope: 'string',
    targetWorkspaceIds: 'list',
    targetLocationIds: 'list',
    targetCount: 'int',
    successfulTargetCount: 'int',
    failedTargetCount: 'int',
    completedAt: 'datetime',
  },
  ElevenLabsDeploymentListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ElevenLabsDeploymentTarget: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    deploymentId: 'string',
    locationId: 'string',
    workspaceId: 'string',
    locationName: 'string',
    agentId: 'string',
    status: 'string',
    clientVars: 'string',
    derivedConfig: 'string',
    compiledBody: 'string',
    tagsNotInConfig: 'list',
    fragmentSnapshots: 'string',
    errorMessage: 'string',
    claimedAt: 'datetime',
    pushedAt: 'datetime',
  },
  ElevenLabsDeploymentTargetListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  EmailAttachment: {
    filename: 'string',
    contentType: 'string',
    sizeBytes: 'float',
  },
  EmailAttachmentLink: {
    filename: 'string',
    contentType: 'string',
    sizeBytes: 'float',
    url: 'string',
  },
  Event: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    type: 'string',
    typeId: 'string',
    action: 'string',
    eventDate: 'datetime',
    source: 'string',
    data: 'string',
    workflowIds: 'list',
    actor: 'string',
    journeyMeta: 'string',
    note: 'string',
  },
  EventListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ExtractionDashboardResult: {
    workspaceId: 'string',
    shadowStats: 'object',
  },
  ExtractionPrompt: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    stage: 'string',
    promptVersion: 'string',
    prompt: 'string',
    model: 'string',
    active: 'boolean',
    createdBy: 'string',
    notes: 'string',
  },
  ExtractionPromptListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  FacebookAccount: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
    isDisabled: 'boolean',
  },
  FacebookAdsConfig: {
    accountId: 'string',
    campaignId: 'string',
    adSetId: 'string',
  },
  FacebookAdSet: {
    id: 'string',
    name: 'string',
  },
  FacebookLeadForm: {
    id: 'string',
    name: 'string',
  },
  FacebookLeadPage: {
    name: 'string',
    value: 'string',
  },
  FacebookLeadPageConfig: {
    id: 'string',
    formIds: 'list',
  },
  FeatureToggle: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    name: 'string',
    type: 'string',
    typeId: 'string',
    description: 'string',
    displayName: 'string',
    category: 'string',
    release: 'string',
    archived: 'boolean',
    createdBy: 'string',
    updatedBy: 'string',
  },
  FeatureToggleListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  FileImport: {
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    fileName: 'string',
    importIds: 'list',
    archived: 'boolean',
    createdDate: 'datetime',
    updatedDate: 'datetime',
  },
  FileImportListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  FollowUpGQL: {
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    contactId: 'string',
    ownerName: 'string',
    ownerId: 'string',
    appointmentDate: 'datetime',
    followUpDate: 'datetime',
    isConnected: 'boolean',
    isScheduled: 'boolean',
    description: 'string',
    associatedType: 'string',
    associatedTypeId: 'string',
    associatedPeopleIndex: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
  },
  FollowUpGQLListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  FormFieldMapping: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    rawKey: 'string',
    formField: 'string',
  },
  FormFieldMappingListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  FormSubmissionsNotificationSettings: {
    enabled: 'boolean',
    newFormSubmission: 'object',
  },
  FormTemplate: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    formId: 'string',
    name: 'string',
    description: 'string',
    category: 'string',
    formVersion: 'int',
    status: 'string',
    publishedDate: 'datetime',
    archived: 'boolean',
    questionsJson: 'string',
  },
  FormTemplateListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  GoogleAdsAccount: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
    isDisabled: 'boolean',
  },
  GoogleAdsV2Config: {
    accountId: 'string',
    campaignId: 'string',
    adGroupId: 'string',
  },
  GoogleAdsV3Config: {
    accountId: 'string',
    campaignIds: 'list',
    conversionActions: 'string',
  },
  GravityFormsMultiConfig: {
    apiKey: 'string',
    defaultLocationId: 'string',
    routingRules: 'list',
  },
  GravityFormsRoutingField: {
    name: 'string',
    value: 'string',
  },
  GravityFormsRoutingRule: {
    locationId: 'string',
    formId: 'string',
    field: 'object',
  },
  Import: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    locationId: 'string',
    workspaceId: 'string',
    name: 'string',
    type: 'string',
    vendor: 'string',
    phone: 'string',
    email: 'string',
    treatment: 'string',
    requestedAppointmentTime: 'string',
    utmSource: 'string',
    utmMedium: 'string',
    utmCampaign: 'string',
    isScheduled: 'boolean',
    channel: 'string',
    staff: 'string',
    archived: 'boolean',
    fileImportId: 'string',
    activityDate: 'datetime',
  },
  ImportListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  IncomingCall: {
    id: 'string',
    workspaceId: 'string',
    locationId: 'string',
    callerPhone: 'string',
    callerName: 'string',
    callerCity: 'string',
    callerState: 'string',
    source: 'string',
    trackingNumber: 'string',
    trackingNumberName: 'string',
    startedAt: 'datetime',
    contactIds: 'list',
  },
  InitiateCallResult: {
    success: 'boolean',
    callId: 'string',
    calledNumber: 'string',
    error: 'string',
  },
  IntegrationOptionsQueries: {
    ringCentralPhoneNumbers: 'list',
    callRailCompanies: 'list',
    sikkaOffices: 'list',
    ascendLocations: 'list',
    carestackPractices: 'list',
    jotformForms: 'list',
    twilioPhoneNumbers: 'list',
    googleAdsAccounts: 'list',
    googleAdsAccount: 'object',
    facebookAccounts: 'list',
    facebookAdSets: 'list',
    facebookLeadPages: 'list',
    facebookLeadForms: 'list',
    kollaPractices: 'list',
    callrailTags: 'list',
    elevenLabsAgents: 'list',
  },
  IntegrationSaveResult: {
    success: 'boolean',
    error: 'string',
  },
  IntegrationStatus: {
    status: 'string',
    reason: 'string',
    detail: 'object',
    remainingPatients: 'int',
    remainingTransactions: 'int',
    remainingAppointments: 'int',
    remainingCalls: 'int',
    remainingForms: 'int',
    remainingSpendRecords: 'int',
    configuredPages: 'int',
    completion: 'int',
    patientsCompletion: 'int',
    transactionsCompletion: 'int',
    appointmentsCompletion: 'int',
  },
  IntegrationStatusDetail: {
    completionPercent: 'int',
    daysStaleSince: 'int',
  },
  IntegrationV2: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    sourceId: 'string',
    sourceType: 'string',
    type: 'string',
    username: 'string',
  },
  IvrConfigResult: {
    id: 'string',
    locationId: 'string',
    phoneNumberId: 'string',
    enabled: 'boolean',
    root: 'string',
    nodes: 'string',
  },
  JotformConfig: {
    folderId: 'string',
    formIds: 'list',
  },
  JotformForm: {
    id: 'string',
    name: 'string',
    labelId: 'string',
    labelName: 'string',
    isUsed: 'boolean',
    usedByLocationName: 'string',
  },
  JotformV2Config: {
    labelId: 'string',
    formIds: 'list',
  },
  KollaPractice: {
    id: 'string',
    name: 'string',
  },
  KollaRequestResult: {
    success: 'boolean',
    error: 'string',
    data: 'string',
    responseTimeMs: 'int',
  },
  LeadOverrideConfig: {
    amount: 'float',
    unit: 'string',
  },
  LeadsBreakdownBucket: {
    key: 'string',
    count: 'int',
  },
  LegacyLeadsBreakdown: {
    total: 'int',
    buckets: 'list',
    byActivityTypes: 'list',
    byLeadStatus: 'list',
    byLeadStatusComparison: 'list',
    rows: 'list',
  },
  LegacyLeadsByStatus: {
    status: 'string',
    count: 'int',
  },
  LegacyLeadsByType: {
    type: 'string',
    count: 'int',
  },
  LegacyLeadsDailyMetric: {
    date: 'string',
    bucket: 'string',
    leads: 'int',
    leadsByFirstActivityType: 'list',
    leadsByStatus: 'list',
  },
  LegacyLeadsMetric: {
    bucket: 'string',
    leads: 'int',
  },
  List: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    entityType: 'string',
    stages: 'list',
    defaultStageId: 'string',
    filters: 'list',
    join: 'string',
    system: 'boolean',
    createdByUserId: 'string',
    visibility: 'string',
  },
  ListItem: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    listId: 'string',
    entityId: 'string',
    stageId: 'string',
  },
  ListItemListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ListMember: {
    type: 'string',
    entityId: 'string',
    stageId: 'string',
  },
  ListMembersResult: {
    members: 'list',
    total: 'int',
    page: 'int',
  },
  ListStage: {
    id: 'string',
    name: 'string',
    color: 'string',
    system: 'boolean',
  },
  ListStageCount: {
    stageId: 'string',
    count: 'int',
  },
  Location: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    pms: 'string',
    pmsIntegratedDate: 'datetime',
    migrationDate: 'datetime',
    sikkaOfficeId: 'string',
    sikkaPracticeId: 'string',
    kollaConnectorId: 'string',
    kollaConsumerId: 'string',
    kollaPracticeId: 'string',
    kollaPageSize: 'int',
    availabilityMode: 'string',
    callRailCompanyId: 'string',
    elevenLabsAgentId: 'string',
    callRailBackfillStartDate: 'datetime',
    jotformFormIds: 'list',
    facebookFormIds: 'list',
    carestackId: 'string',
    ringCentralPhoneNumbers: 'list',
    twilioNumbers: 'list',
    primaryNumberId: 'string',
    officeTransferNumberId: 'string',
    googleAdsCustomerId: 'string',
    facebookAdSetIds: 'list',
    city: 'string',
    state: 'string',
    address: 'string',
    zip: 'string',
    phone: 'string',
    description: 'string',
    addressLine2: 'string',
    timezone: 'string',
    openHours: 'object',
    tags: 'list',
    orgTags: 'list',
    labels: 'list',
    products: 'list',
    type: 'string',
    callRailRouting: 'list',
    primaryTrackingNumber: 'string',
    primarySmsNumber: 'string',
    businessPhone: 'string',
    officeMainNumber: 'string',
    officeTransferNumber: 'string',
    jotFormIgnoredForms: 'list',
    lastPmsSyncDate: 'datetime',
    lastSyncFailureDate: 'datetime',
    lastPmsSyncStartDate: 'datetime',
    lastPmsSyncCompleteDate: 'datetime',
    currentStatus: 'string',
    notes: 'list',
    lastRingCentralSyncDate: 'datetime',
    lastCallrailWebhookDate: 'datetime',
    lastCallrailSyncDate: 'datetime',
    lastTwilioWebhookDate: 'datetime',
    lastAICallDate: 'datetime',
    lastSikkaWebhookDate: 'datetime',
    lastJotformWebhookDate: 'datetime',
    lastFacebookWebhookDate: 'datetime',
    facebookSpendUpdateDate: 'datetime',
    googleSpendUpdateDate: 'datetime',
    facebookAdsActive: 'boolean',
    googleAdsActive: 'boolean',
    isSchedulerLive: 'boolean',
    isAIAgentLive: 'boolean',
    allowDoubleBookingScheduling: 'boolean',
    gravityFormsKey: 'string',
    webflowFormsKey: 'string',
    clickFunnelsKey: 'string',
    lastClickFunnelsWebhookDate: 'datetime',
    googleAdsV2: 'list',
    googleAdsV3: 'object',
    facebookAdsV2: 'list',
    facebookLeadsPages: 'list',
    jotform: 'list',
    jotformV2: 'list',
    settings: 'object',
    archived: 'boolean',
    lastGravityFormWebhookDate: 'datetime',
    lastPatientSyncDate: 'datetime',
    lastAppointmentSyncDate: 'datetime',
    lastTransactionSyncDate: 'datetime',
    lastProcedureSyncDate: 'datetime',
    lastVisitSyncDate: 'datetime',
    lastReferralSourceSyncDate: 'datetime',
    lastTreatmentPlanSyncDate: 'datetime',
    lastCommLogSyncDate: 'datetime',
    lastPatientReceivedDate: 'datetime',
    lastAppointmentReceivedDate: 'datetime',
    lastTransactionReceivedDate: 'datetime',
    lastProcedureReceivedDate: 'datetime',
    lastVisitReceivedDate: 'datetime',
    lastReferralSourceReceivedDate: 'datetime',
    lastTreatmentPlanReceivedDate: 'datetime',
    lastCommLogReceivedDate: 'datetime',
    ascendLocationId: 'string',
    alarmQuietStart: 'string',
    alarmQuietEnd: 'string',
    dailySyncHour: 'int',
    pmsIntegrated: 'boolean',
  },
  LocationEmailIdentity: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    sendingDomainId: 'string',
    domain: 'string',
    localPart: 'string',
    address: 'string',
    fromName: 'string',
    replyTo: 'string',
  },
  LocationEmailIdentityListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  LocationListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  LocationNote: {
    text: 'string',
    date: 'datetime',
    userId: 'string',
  },
  LocationOpenDay: {
    hours: 'list',
    open: 'boolean',
  },
  LocationOpenHours: {
    sunday: 'object',
    monday: 'object',
    tuesday: 'object',
    wednesday: 'object',
    thursday: 'object',
    friday: 'object',
    saturday: 'object',
  },
  LocationSettings: {
    newPatientCalculation: 'string',
    appointmentsSetNewPatient: 'boolean',
    appointmentCompletionStatuses: 'list',
    transactionBrokenCodes: 'list',
    newPatientCodes: 'list',
    ignorePII: 'boolean',
    excludeParentsFromNewPatients: 'boolean',
    firstVisitSetNewPatient: 'boolean',
    commLogWritebackEnabled: 'boolean',
    commLogWritebackEnabledDate: 'datetime',
    commLogWritebackChannels: 'string',
    commLogWritebackProvider: 'string',
  },
  LoginPayload: {
    pendingToken: 'string',
    channel: 'string',
    accessToken: 'string',
    user: 'object',
  },
  MarketingLeadsByType: {
    type: 'string',
    leads: 'int',
    mqls: 'int',
    appointments: 'int',
    patients: 'int',
  },
  MarketingMetrics: {
    budget: 'float',
    production: 'float',
    scheduledProduction: 'float',
    ROI: 'float',
    leads: 'int',
    MQLs: 'int',
    mqls: 'int',
    appointments: 'int',
    patients: 'int',
    CPL: 'float',
    CPQL: 'float',
    CPA: 'float',
    CAC: 'float',
    leadsClosedWon: 'int',
    leadsNeedsAction: 'int',
    leadsScheduled: 'int',
    leadsInProgress: 'int',
    leadsClosedLost: 'int',
    scheduleRate: 'float',
    qualified: 'int',
    disqualified: 'int',
    scheduled: 'int',
    closedWon: 'int',
    closedLost: 'int',
    facebookSpend: 'float',
    googleSpend: 'float',
    targetSpend: 'float',
    leadGoal: 'int',
    patientGoal: 'int',
    leadsByFirstActivityType: 'list',
  },
  MarketingMetricsResponse: {
    summary: 'object',
    compareTo: 'object',
    hits: 'list',
    rows: 'list',
    total: 'int',
  },
  MarketingMetricsRow: {
    budget: 'float',
    production: 'float',
    scheduledProduction: 'float',
    ROI: 'float',
    leads: 'int',
    MQLs: 'int',
    mqls: 'int',
    appointments: 'int',
    patients: 'int',
    CPL: 'float',
    CPQL: 'float',
    CPA: 'float',
    CAC: 'float',
    leadsClosedWon: 'int',
    leadsNeedsAction: 'int',
    leadsScheduled: 'int',
    leadsInProgress: 'int',
    leadsClosedLost: 'int',
    scheduleRate: 'float',
    qualified: 'int',
    disqualified: 'int',
    scheduled: 'int',
    closedWon: 'int',
    closedLost: 'int',
    facebookSpend: 'float',
    googleSpend: 'float',
    targetSpend: 'float',
    leadGoal: 'int',
    patientGoal: 'int',
    leadsByFirstActivityType: 'list',
    bucket: 'string',
    locationId: 'string',
    workspaceId: 'string',
    yearMonth: 'string',
    cpls: 'float',
    roi: 'float',
    iCPL: 'float',
    iCPQL: 'float',
    byChannel: 'list',
  },
  Message: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    threadId: 'string',
    from: 'string',
    to: 'string',
    callerId: 'string',
    sentByUserId: 'string',
    isAgent: 'boolean',
    isInitialMessage: 'boolean',
    aiWorkflowId: 'string',
    aiWorkflowName: 'string',
    workflowRunId: 'string',
    direction: 'string',
    source: 'string',
    replyDelay: 'float',
    replyFrom: 'string',
    contactId: 'string',
    channel: 'string',
    category: 'string',
    subject: 'string',
    htmlBody: 'string',
    replyTo: 'string',
    fromName: 'string',
    text: 'string',
    read: 'boolean',
    archived: 'boolean',
    status: 'string',
    provider: 'string',
    providerMessageId: 'string',
    errorCode: 'string',
    errorMessage: 'string',
    images: 'list',
    attachments: 'list',
    sendDate: 'datetime',
    sentDate: 'datetime',
  },
  MessageListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  MonthlyBucket: {
    month: 'string',
    count: 'int',
    byChannel: 'list',
  },
  Mutation: {
    login: 'object',
    verifyOtp: 'object',
    loginWithGoogleCode: 'object',
    switchWorkspace: 'object',
    impersonateUser: 'object',
    logout: 'boolean',
    resetPassword: 'boolean',
    setPassword: 'object',
    updateMe: 'object',
    setupIntegration: 'object',
    removeIntegration: 'boolean',
    updateFacebookLeadPages: 'object',
    bindLocationElevenLabsAgent: 'object',
    unbindLocationElevenLabsAgent: 'object',
    createCommLog: 'object',
    createAction: 'object',
    updateAction: 'object',
    deleteAction: 'boolean',
    updateNote: 'object',
    updateMilestone: 'object',
    reassignActivity: 'object',
    addActivityTags: 'object',
    removeActivityTags: 'object',
    deleteActivity: 'boolean',
    createNote: 'object',
    rematchActivity: 'object',
    createAdPlatformMapping: 'object',
    updateAdPlatformMapping: 'object',
    deleteAdPlatformMapping: 'boolean',
    updateAIAgentLocationConfig: 'object',
    createWorkflow: 'object',
    updateWorkflow: 'object',
    deleteWorkflow: 'boolean',
    enroll: 'object',
    triggerWorkflowOnContact: 'object',
    cancelWorkflowRun: 'object',
    updateAppointmentType: 'object',
    createAvailability: 'object',
    updateAvailability: 'object',
    deleteProviderAvailability: 'boolean',
    createBudget: 'object',
    updateBudget: 'object',
    deleteBudget: 'object',
    initiateCall: 'object',
    updateCall: 'object',
    deleteCall: 'boolean',
    createCallData: 'object',
    updateCallData: 'object',
    deleteCallData: 'boolean',
    createCdtCodeMapping: 'object',
    updateCdtCodeMapping: 'object',
    deleteCdtCodeMapping: 'boolean',
    createCustomPage: 'object',
    updateCustomPage: 'object',
    deleteCustomPage: 'boolean',
    createChannelMapping: 'object',
    updateChannelMapping: 'object',
    deleteChannelMapping: 'boolean',
    createCommLogWritebackRule: 'object',
    updateCommLogWritebackRule: 'object',
    deleteCommLogWritebackRule: 'boolean',
    createContact: 'object',
    updateContact: 'object',
    addTags: 'object',
    removeTags: 'object',
    addToPipeline: 'object',
    mergeContacts: 'object',
    recalculateContact: 'object',
    createExtractionPrompt: 'object',
    updateExtractionPrompt: 'object',
    createFeatureToggle: 'object',
    updateFeatureToggle: 'object',
    deleteFeatureToggle: 'boolean',
    createFileImport: 'object',
    deleteFileImport: 'boolean',
    createFollowUp: 'object',
    updateFollowUp: 'object',
    deleteFollowUp: 'boolean',
    createFormFieldMapping: 'object',
    updateFormFieldMapping: 'object',
    deleteFormFieldMapping: 'boolean',
    createFormTemplate: 'object',
    updateFormTemplate: 'object',
    publishFormTemplate: 'object',
    draftNextFormTemplateVersion: 'object',
    deleteFormTemplate: 'boolean',
    createPaperworkTemplate: 'object',
    updatePaperworkTemplate: 'object',
    deletePaperworkTemplate: 'boolean',
    createPaperwork: 'object',
    resendPaperwork: 'object',
    cancelPaperwork: 'object',
    submitPaperworkForm: 'object',
    createDni: 'object',
    updateDni: 'object',
    deleteDni: 'boolean',
    createImport: 'object',
    createIvrConfig: 'object',
    updateIvrConfig: 'object',
    createLocation: 'object',
    updateLocation: 'object',
    deleteLocation: 'boolean',
    updateBlockoutNotes: 'object',
    sendSms: 'object',
    sendContactEmail: 'object',
    markMessageRead: 'object',
    archiveMessage: 'object',
    linkMessageToContact: 'object',
    cancelScheduledMessage: 'object',
    updateNotification: 'object',
    markAllNotificationsRead: 'object',
    resetNotificationUnseen: 'object',
    updateUserNotificationSettings: 'object',
    createOptOut: 'object',
    updateOptOut: 'object',
    deleteOptOut: 'boolean',
    createPhoneNumber: 'object',
    updatePhoneNumber: 'object',
    createSendingDomain: 'object',
    verifySendingDomain: 'object',
    deleteSendingDomain: 'boolean',
    setLocationEmailIdentity: 'object',
    deleteLocationEmailIdentity: 'boolean',
    createPipeline: 'object',
    updatePipeline: 'object',
    deletePipeline: 'boolean',
    createList: 'object',
    updateList: 'object',
    deleteList: 'boolean',
    createListItem: 'object',
    updateListItem: 'object',
    deleteListItem: 'boolean',
    createPmsReferralMapping: 'object',
    updatePmsReferralMapping: 'object',
    updateProvider: 'object',
    createRole: 'object',
    updateRole: 'object',
    deleteRole: 'boolean',
    createScorecard: 'object',
    updateScorecard: 'object',
    createStaff: 'object',
    updateStaff: 'object',
    deleteStaff: 'boolean',
    updateSchedulingConfiguration: 'object',
    createTagColor: 'object',
    updateTagColor: 'object',
    deleteTagColor: 'boolean',
    createSmsTemplate: 'object',
    updateSmsTemplate: 'object',
    deleteSmsTemplate: 'boolean',
    createNoteTemplate: 'object',
    updateNoteTemplate: 'object',
    deleteNoteTemplate: 'boolean',
    createTask: 'object',
    updateTask: 'object',
    deleteTask: 'boolean',
    createTaskTemplate: 'object',
    updateTaskTemplate: 'object',
    deleteTaskTemplate: 'boolean',
    createThread: 'object',
    updateThread: 'object',
    threadEngageAgent: 'object',
    createUser: 'object',
    updateUser: 'object',
    deleteUser: 'boolean',
    saveUserSettings: 'object',
    createUtmAlias: 'object',
    updateUtmAlias: 'object',
    deleteUtmAlias: 'boolean',
    createWorkspace: 'object',
    updateWorkspace: 'object',
    confirmMarketingConsent: 'object',
    deleteWorkspace: 'boolean',
    addWorkspaceOrgTag: 'object',
    removeWorkspaceOrgTag: 'object',
    createWorkspaceInvite: 'object',
    updateWorkspaceInvite: 'object',
    deleteWorkspaceInvite: 'boolean',
    createRegistrationProfile: 'object',
    updateRegistrationProfile: 'object',
    addLocationNote: 'object',
    deleteLocationNote: 'object',
    pingKollaConnector: 'object',
    compareData: 'object',
    kollaRequest: 'object',
    ascendRequest: 'object',
    opsUpdateAIAgentConfiguration: 'object',
    opsUpdateAIAgentCompilerConfig: 'object',
    opsSetUserType: 'object',
    cacheFlush: 'object',
    cacheSearch: 'string',
    cacheDelete: 'string',
    syncProviders: 'object',
    syncSchedules: 'object',
    saveGravityFormsIntegration: 'object',
    saveWebflowFormsIntegration: 'object',
    saveFacebookAdsIntegration: 'object',
    saveCallRailIntegration: 'object',
    saveCarestackIntegration: 'object',
    saveAscendIntegration: 'object',
    saveSikkaIntegration: 'object',
    saveRingCentralIntegration: 'object',
    saveTwilioIntegration: 'object',
    saveKollaIntegration: 'object',
    removeLocationIntegration: 'object',
    purchasePhoneNumber: 'object',
    releasePhoneNumber: 'object',
    setWorkflowCategory: 'object',
    updateSuperNotifications: 'object',
    createPrompt: 'object',
    updatePrompt: 'object',
    createPromptDraft: 'object',
    deletePromptDraft: 'boolean',
    promotePromptDraft: 'object',
    createPromptFragment: 'object',
    updatePromptFragment: 'object',
    createElevenLabsDeployment: 'object',
    deployElevenLabsPrompt: 'object',
    opsUpdateAIAgentLocationConfig: 'object',
    createStoredCredential: 'object',
    updateStoredCredential: 'object',
    deleteStoredCredential: 'boolean',
  },
  NewPatientsLocationRow: {
    bucket: 'string',
    location: 'object',
    reappointmentPercentage: 'float',
    reappointments: 'int',
    completed: 'int',
    brokenAppointmentCount: 'int',
    averageTimeToAppointment: 'float',
    averageProductionPerNewPatientVisit: 'float',
    newPatients: 'int',
    newPatientsFromDigitalMarketing: 'int',
    newPatientsFromReferralMarketing: 'int',
    newPatientsFromTraditionalMarketing: 'int',
    newPatientsFromUnknown: 'int',
    scheduledNewPatients: 'int',
  },
  NewPatientsLocationSummary: {
    id: 'string',
    name: 'string',
    pmsIntegrated: 'boolean',
    lastPmsSyncDate: 'string',
  },
  NewPatientsMetricBucket: {
    bucket: 'string',
    count: 'int',
    byChannel: 'list',
  },
  NewPatientsMetricsResponse: {
    summary: 'object',
    comparisonSummary: 'object',
    monthlyBuckets: 'list',
    dailyMetrics: 'list',
    comparisonMetrics: 'list',
    dailyScheduledMetrics: 'list',
    rows: 'list',
  },
  NewPatientsMonthlyBreakdownRow: {
    bucket: 'string',
    reappointmentPercentage: 'float',
    brokenAppointmentCount: 'int',
    averageTimeToAppointment: 'float',
    averageProductionPerNewPatientVisit: 'float',
    newPatients: 'int',
    scheduledNewPatients: 'int',
  },
  NewPatientsSummary: {
    completed: 'int',
    scheduled: 'int',
    reappointmentPercentage: 'float',
    averageTimeToAppointment: 'float',
    averageProductionPerNewPatientVisit: 'float',
    reappointments: 'int',
    byChannel: 'list',
  },
  NoteTemplate: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    body: 'string',
  },
  NoteTemplateListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Notification: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    userId: 'string',
    triggerDate: 'string',
    objectType: 'string',
    medium: 'string',
    locationId: 'string',
    types: 'list',
    activityId: 'string',
    contactId: 'string',
    messageId: 'string',
    workflowId: 'string',
    workflowStep: 'string',
    workflowReason: 'string',
    read: 'boolean',
    managedNotification: 'boolean',
    clicked: 'boolean',
    archived: 'boolean',
  },
  NotificationChannel: {
    email: 'boolean',
    app: 'boolean',
    popup: 'boolean',
    sound: 'boolean',
  },
  NotificationCommandResult: {
    success: 'boolean',
    error: 'string',
  },
  NotificationListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  OpenHoursRange: {
    from: 'string',
    to: 'string',
  },
  Operatory: {
    name: 'string',
    remote_id: 'string',
    type: 'string',
    display_name: 'string',
    id: 'string',
    locationId: 'string',
  },
  OpsLocation: {
    id: 'string',
    name: 'string',
    orgId: 'string',
    workspaceId: 'string',
    pms: 'string',
    timezone: 'string',
    connectorType: 'string',
    kollaConnectorId: 'string',
    kollaConsumerId: 'string',
    kollaPracticeId: 'string',
    kollaPageSize: 'int',
    sikkaOfficeId: 'string',
    sikkaPracticeId: 'string',
    carestackId: 'string',
    lastSyncAt: 'datetime',
    lastPmsSyncDate: 'datetime',
    lastPatientSyncDate: 'datetime',
    lastAppointmentSyncDate: 'datetime',
    lastTransactionSyncDate: 'datetime',
    lastProcedureSyncDate: 'datetime',
    lastTreatmentPlanSyncDate: 'datetime',
    lastPatientReceivedDate: 'datetime',
    lastAppointmentReceivedDate: 'datetime',
    lastTransactionReceivedDate: 'datetime',
    lastProcedureReceivedDate: 'datetime',
    lastTreatmentPlanReceivedDate: 'datetime',
    lastPmsSyncStartDate: 'datetime',
    lastPmsSyncCompleteDate: 'datetime',
    lastSikkaWebhookDate: 'datetime',
    pmsIntegratedDate: 'datetime',
    healthStatus: 'string',
    hasError: 'boolean',
    latestError: 'string',
    latestErrorAt: 'datetime',
    workflowStatus: 'string',
    alarmQuietStart: 'string',
    alarmQuietEnd: 'string',
    dailySyncHour: 'int',
    notes: 'list',
  },
  OpsLocationConnection: {
    nodes: 'list',
    pageInfo: 'object',
  },
  OpsUser: {
    id: 'string',
    name: 'string',
    email: 'string',
  },
  OpsUserListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  OpsUserLogin: {
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    email: 'string',
    archived: 'boolean',
    lastLoginDate: 'datetime',
  },
  OpsUserLoginListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  OpsUserType: {
    id: 'string',
    name: 'string',
    email: 'string',
    type: 'string',
  },
  OpsWorkspaceSearchResult: {
    workspaceId: 'string',
    workspaceName: 'string',
    orgId: 'string',
    locationId: 'string',
    locationName: 'string',
  },
  OptOut: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    type: 'string',
    key: 'string',
    cause: 'string',
  },
  OptOutListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  PageInfo: {
    hasNextPage: 'boolean',
    hasPreviousPage: 'boolean',
    total: 'int',
  },
  Paperwork: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    paperworkTemplateId: 'string',
    patientId: 'string',
    token: 'string',
    expiresDate: 'datetime',
    status: 'string',
    openedDate: 'datetime',
    completedDate: 'datetime',
    cancelledDate: 'datetime',
    snapshotJson: 'string',
    submissionsJson: 'string',
    processingStatus: 'string',
    processingCompletedDate: 'datetime',
    chartWritesJson: 'string',
    link: 'string',
    fullyComplete: 'boolean',
    formStatuses: 'list',
    chartWriteStatuses: 'list',
  },
  PaperworkChartWrite: {
    formId: 'string',
    status: 'string',
    externalId: 'string',
    errorMessage: 'string',
    completedDate: 'datetime',
  },
  PaperworkFormStatus: {
    formId: 'string',
    name: 'string',
    completed: 'boolean',
    submittedDate: 'datetime',
  },
  PaperworkListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  PaperworkTemplate: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    description: 'string',
    archived: 'boolean',
    formsJson: 'string',
    brandingJson: 'string',
    appearanceJson: 'string',
    welcomeJson: 'string',
    completionJson: 'string',
  },
  PaperworkTemplateListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Patient: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    locationId: 'string',
    workspaceId: 'string',
    pmsPatientId: 'string',
    sikkaOfficeId: 'string',
    sikkaPracticeId: 'string',
    firstName: 'string',
    lastName: 'string',
    preferredName: 'string',
    birthDate: 'datetime',
    gender: 'string',
    addressLine1: 'string',
    addressLine2: 'string',
    city: 'string',
    state: 'string',
    zip: 'string',
    email: 'string',
    homePhone: 'string',
    workPhone: 'string',
    cellPhone: 'string',
    phoneme: 'string',
    patientCreatedDate: 'datetime',
    firstVisit: 'datetime',
    lastVisit: 'datetime',
    firstActivityDate: 'datetime',
    status: 'string',
    insuranceProvider: 'string',
    subscriberId: 'string',
    referralType: 'string',
    patientReferral: 'string',
    guarantorId: 'string',
    guarantorFirstName: 'string',
    guarantorLastName: 'string',
    vendor: 'string',
    smsOptIn: 'boolean',
    emailOptIn: 'boolean',
  },
  PatientListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  PhoneCallsNotificationSettings: {
    enabled: 'boolean',
    canceledAppointment: 'object',
    allUnscheduledCalls: 'object',
    newPatientUnscheduledCalls: 'object',
    callbackRequested: 'object',
    missedCalls: 'object',
    voicemail: 'object',
    incomingCall: 'object',
  },
  PhoneNumber: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    phone: 'string',
    provider: 'string',
    providerResourceId: 'string',
    roles: 'list',
    label: 'string',
    registrationStatus: 'string',
    registrationId: 'string',
    enabled: 'boolean',
    provisioningStatus: 'string',
    provisioningError: 'string',
  },
  PhoneNumberListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  PingResult: {
    success: 'boolean',
    message: 'string',
    responseTimeMs: 'int',
  },
  Pipeline: {
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    stages: 'list',
  },
  PipelineStage: {
    name: 'string',
    color: 'string',
    order: 'int',
  },
  PmsDataNotificationSettings: {
    enabled: 'boolean',
    noPatientLinkedOnScheduledContact: 'object',
    noAppointmentFoundOnScheduledContact: 'object',
    brokenAppointment: 'object',
  },
  PmsReferralMapping: {
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    source: 'string',
    medium: 'string',
    campaign: 'string',
    channel: 'string',
    referralType: 'string',
    force: 'boolean',
  },
  PmsReferralMappingListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Procedure: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    vendorId: 'string',
    vendor: 'string',
    patientId: 'string',
    procedureCode: 'string',
    description: 'string',
    tooth: 'string',
    state: 'string',
    providerId: 'string',
    priority: 'string',
    billedAmount: 'float',
    feeAmount: 'float',
    appointmentIds: 'list',
    planIds: 'list',
    procedureCreateDate: 'datetime',
    procedureUpdateDate: 'datetime',
  },
  ProcedureListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Prompt: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    key: 'string',
    category: 'string',
    name: 'string',
    description: 'string',
    model: 'string',
    temperature: 'float',
    archived: 'boolean',
    body: 'string',
    revision: 'int',
    draftCounter: 'int',
    updatedBy: 'string',
    lastDeployedVersionId: 'string',
  },
  PromptDraft: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    promptId: 'string',
    promptKey: 'string',
    promptName: 'string',
    draftNumber: 'int',
    friendlyName: 'string',
    baseVersionId: 'string',
    editor: 'string',
    savedAt: 'datetime',
    body: 'string',
  },
  PromptDraftListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  PromptFragment: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    name: 'string',
    description: 'string',
    editor: 'string',
    body: 'string',
    revision: 'int',
    archived: 'boolean',
  },
  PromptFragmentListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  PromptListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  PromptVersion: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    promptId: 'string',
    promptKey: 'string',
    promptName: 'string',
    revision: 'int',
    category: 'string',
    model: 'string',
    temperature: 'float',
    editor: 'string',
    savedAt: 'datetime',
    changeSummary: 'string',
    body: 'string',
    isCurrent: 'boolean',
  },
  PromptVersionListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Provider: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    practiceIds: 'list',
    resourceName: 'string',
    vendorId: 'string',
    displayName: 'string',
    pmsDisplayName: 'string',
    pmsShortDisplayName: 'string',
    taxonomy: 'string',
    kollaConsumerId: 'string',
    deactivated: 'boolean',
    vendor: 'string',
    hasProfilePicture: 'boolean',
    priority: 'float',
    isPrimary: 'boolean',
  },
  ProviderListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  PublicPaperwork: {
    linkState: 'string',
    practice: 'object',
    status: 'string',
    expiresDate: 'datetime',
    packet: 'string',
    submittedFormIds: 'string',
  },
  PublicPaperworkPractice: {
    displayName: 'string',
    phone: 'string',
    logoUrl: 'string',
  },
  QualifiedLeadCounts: {
    total: 'int',
    qualified: 'int',
    disqualified: 'int',
    stats: 'object',
    comparisonStats: 'object',
    staffConversionMetrics: 'list',
    series: 'list',
  },
  QualifiedLeadSeriesRow: {
    date: 'string',
    scheduled: 'int',
    leads: 'int',
    scheduledRate: 'float',
  },
  QualifiedLeadStats: {
    scheduleRate: 'float',
    mqls: 'int',
    scheduled: 'int',
    notScheduled: 'int',
  },
  Query: {
    me: 'object',
    activateAccount: 'object',
    integrationOptions: 'object',
    integrationStatus: 'object',
    integration: 'object',
    procedures: 'object',
    procedure: 'object',
    commLogs: 'object',
    commLog: 'object',
    pmsUserName: 'string',
    pmsCommTypeName: 'string',
    actions: 'object',
    action: 'object',
    actionHistory: 'object',
    activities: 'object',
    activity: 'object',
    campaigns: 'object',
    campaign: 'object',
    adPlatformMappings: 'object',
    aiAgentConfiguration: 'object',
    aiConversationTurns: 'object',
    aiConversationTurn: 'object',
    aiAgentCallLog: 'object',
    workflows: 'object',
    workflow: 'object',
    workflowDateTriggerFields: 'list',
    previewWorkflowTrigger: 'object',
    workflowRuns: 'object',
    workflowRun: 'object',
    workflowRunEvents: 'object',
    appointments: 'object',
    appointment: 'object',
    appointmentTypes: 'object',
    providerAvailabilities: 'list',
    operatories: 'list',
    budgets: 'object',
    callRecordingUrl: 'string',
    callTranscription: 'string',
    calls: 'object',
    incomingCalls: 'list',
    call: 'object',
    callerId: 'object',
    callData: 'object',
    callDatum: 'object',
    cdtCodeMappings: 'object',
    customPages: 'object',
    customPage: 'object',
    channelMappings: 'object',
    commLogWritebackRules: 'object',
    contacts: 'object',
    contact: 'object',
    conversionLogs: 'object',
    events: 'object',
    event: 'object',
    extractionPrompts: 'object',
    extractionPrompt: 'object',
    featureToggles: 'object',
    featureToggleDefinitions: 'object',
    featureTogglesByName: 'list',
    fileImports: 'object',
    fileImport: 'object',
    followUps: 'object',
    followUp: 'object',
    formFieldMappings: 'object',
    formTemplates: 'object',
    formTemplate: 'object',
    paperworkTemplates: 'object',
    paperworkTemplate: 'object',
    paperworks: 'object',
    paperwork: 'object',
    paperworkFormPdfUrl: 'string',
    paperworkFileUrl: 'string',
    paperworkByToken: 'object',
    unmappedFormKeys: 'object',
    dnis: 'object',
    dni: 'object',
    dniPoolNumbers: 'list',
    imports: 'object',
    importDetail: 'object',
    ivrConfig: 'object',
    ivrConfigs: 'list',
    locations: 'object',
    location: 'object',
    locationsByIds: 'list',
    locationCanSendEmail: 'boolean',
    locationLeadStatuses: 'list',
    locationOutboundNumbers: 'list',
    locationSmsNumbers: 'list',
    locationIvrNumbers: 'list',
    blockoutNotes: 'list',
    messages: 'object',
    message: 'object',
    messageImageUrls: 'list',
    emailAttachmentUrls: 'list',
    notifications: 'object',
    notification: 'object',
    userNotificationSettings: 'object',
    optOuts: 'object',
    optOut: 'object',
    patients: 'object',
    patient: 'object',
    phoneNumbers: 'object',
    phoneNumber: 'object',
    trackableSendingDomain: 'string',
    sendingDomains: 'object',
    sendingDomain: 'object',
    locationEmailIdentities: 'object',
    locationEmailIdentity: 'object',
    checkSendingEmailAvailable: 'boolean',
    pipelines: 'list',
    pipeline: 'object',
    lists: 'list',
    list: 'object',
    listMembers: 'object',
    listStageCounts: 'list',
    listItems: 'object',
    listItem: 'object',
    pmsReferralMappings: 'object',
    providers: 'object',
    provider: 'object',
    role: 'object',
    roles: 'object',
    resourceSchedules: 'object',
    resourceSchedule: 'object',
    scorecards: 'object',
    staffMember: 'object',
    staffMembers: 'object',
    schedulers: 'object',
    scheduler: 'object',
    schedulingConfigurations: 'object',
    schedulingConfiguration: 'object',
    tagColors: 'object',
    tagValues: 'list',
    tagColor: 'object',
    smsTemplates: 'object',
    smsTemplate: 'object',
    noteTemplates: 'object',
    noteTemplate: 'object',
    tasks: 'object',
    task: 'object',
    taskTemplates: 'object',
    taskTemplate: 'object',
    threads: 'object',
    thread: 'object',
    transactions: 'object',
    transaction: 'object',
    treatmentPlans: 'object',
    treatmentPlan: 'object',
    user: 'object',
    users: 'object',
    userSettings: 'string',
    utmAliases: 'object',
    workspace: 'object',
    workspaces: 'object',
    workspaceInvites: 'object',
    workspaceInvite: 'object',
    activityCount: 'object',
    qualifiedLeadCounts: 'object',
    leadsBreakdown: 'object',
    voiceAgentMetrics: 'object',
    marketingMetrics: 'object',
    newPatientsMetrics: 'object',
    newPatientsMonthlyBreakdown: 'list',
    revenueMetrics: 'object',
    conversionMetrics: 'object',
    budgetMetrics: 'object',
    marketingContacts: 'object',
    staffBreakdown: 'object',
    staffCallActivities: 'object',
    scorecardMetrics: 'list',
    registrationProfiles: 'object',
    registrationProfile: 'object',
    registrationProfileDocumentUrls: 'list',
    opsWorkspaceSearch: 'list',
    opsLocation: 'object',
    opsLocations: 'object',
    syncRun: 'object',
    syncRuns: 'object',
    backgroundJob: 'object',
    backgroundJobs: 'object',
    carestackDashboard: 'object',
    opsVoiceAgentMetrics: 'object',
    opsAIAgentConfiguration: 'object',
    opsVoiceAgentLocationMetrics: 'object',
    opsVoiceAgentDailyMetrics: 'object',
    extractionDashboard: 'object',
    userActivity: 'object',
    opsUsageCostMetrics: 'object',
    opsUsageCostVoiceCalls: 'object',
    opsUsageCostSmsThreads: 'object',
    searchAvailablePhoneNumbers: 'list',
    opsUserLogins: 'object',
    opsUsers: 'object',
    getSuperNotifications: 'object',
    smsOpsMetrics: 'object',
    opsSmsLocationMetrics: 'object',
    opsSmsDailyMetrics: 'object',
    opsSmsStaffTakeovers: 'object',
    prompts: 'object',
    prompt: 'object',
    promptVersions: 'object',
    promptVersion: 'object',
    promptDrafts: 'object',
    promptDraft: 'object',
    promptFragments: 'object',
    promptFragment: 'object',
    elevenLabsDeployments: 'object',
    elevenLabsDeployment: 'object',
    elevenLabsDeploymentTargets: 'object',
    aiAgentConfigurations: 'list',
    smsAgentReady: 'boolean',
    storedCredentials: 'object',
    storedCredential: 'object',
    storedCredentialPassword: 'object',
  },
  RegistrationProfile: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    legalBusinessName: 'string',
    ein: 'string',
    businessType: 'string',
    businessIndustry: 'string',
    businessRegistrationCountry: 'string',
    websiteUrl: 'string',
    addressStreet: 'string',
    addressCity: 'string',
    addressState: 'string',
    addressPostalCode: 'string',
    addressCountry: 'string',
    brandName: 'string',
    brandDescription: 'string',
    contactFirstName: 'string',
    contactLastName: 'string',
    contactEmail: 'string',
    contactPhone: 'string',
    contactTitle: 'string',
    termsUrl: 'string',
    privacyPolicyUrl: 'string',
    optInWorkflowDescription: 'string',
    optInUrl: 'string',
    helpMessage: 'string',
    stopMessage: 'string',
    sampleMessages: 'list',
    useCaseDescription: 'string',
    useCaseCategory: 'string',
    videoUrl: 'string',
    agentServiceName: 'string',
    agentDescription: 'string',
    accentColor: 'string',
    monthlyRcsVolume: 'string',
    optInConfirmationMessage: 'string',
    optOutDetails: 'string',
    optInScreenshotUrl: 'string',
    rcsBannerImageKey: 'string',
    rcsLogoImageKey: 'string',
    optInDocuments: 'list',
    supplementalDocuments: 'list',
  },
  RegistrationProfileListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ResourceSchedule: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    kollaConsumerId: 'string',
    name: 'string',
    date: 'string',
    type: 'string',
    blocks: 'list',
    notes: 'list',
  },
  ResourceScheduleBlock: {
    startTime: 'string',
    endTime: 'string',
  },
  ResourceScheduleListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ResourceScheduleNote: {
    startTime: 'string',
    endTime: 'string',
    note: 'string',
    additionalData: 'object',
  },
  ResourceScheduleNoteData: {
    appointmentType: 'string',
  },
  RevenueDailyMetric: {
    bucket: 'string',
    grossProduction: 'float',
    netProduction: 'float',
    collections: 'float',
  },
  RevenueMetricsResponse: {
    stats: 'object',
    comparisonStats: 'object',
    dailyMetrics: 'list',
    comparisonDailyMetrics: 'list',
  },
  RevenueStats: {
    grossProduction: 'float',
    avgGrossProductionPerVisit: 'float',
    adjustments: 'float',
    avgAdjustmentsPerVisit: 'float',
    netProduction: 'float',
    avgNetProductionPerVisit: 'float',
    collections: 'float',
  },
  RingCentralPhoneNumber: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
  },
  Role: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    permissions: 'list',
    isDefault: 'boolean',
  },
  RoleListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  SayThisNotThatRuleType: {
    stopPhrase: 'string',
    replacementPhrase: 'string',
    channel: 'string',
  },
  ScheduledNewPatientsMetricBucket: {
    bucket: 'string',
    count: 'int',
    byChannel: 'list',
  },
  Scheduler: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    name: 'string',
    patientId: 'string',
    appointmentId: 'string',
    email: 'string',
    phone: 'string',
    providerId: 'string',
    operatoryId: 'string',
    day: 'string',
    time: 'string',
    referralURL: 'string',
    utmSource: 'string',
    utmAccountId: 'string',
    utmCampaignId: 'string',
    utmMedium: 'string',
    utmCampaign: 'string',
    utmContent: 'string',
    utmKeywords: 'string',
    gclid: 'string',
    fbclid: 'string',
    birthDate: 'datetime',
    appointmentType: 'string',
    isNewPatient: 'boolean',
    extraFields: 'string',
    source: 'string',
    bookedByUserId: 'string',
  },
  SchedulerListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  SchedulerNotificationSettings: {
    enabled: 'boolean',
    newAppointmentBooked: 'object',
  },
  SchedulingConfiguration: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    customQuestions: 'list',
    leadOverrideEnabled: 'boolean',
    leadOverrideConfig: 'object',
    allowDoubleBooking: 'boolean',
    doubleBookingCount: 'float',
    insurancesAccepted: 'list',
    insurancesRejected: 'list',
    isStateInsuranceAccepted: 'boolean',
    granularity: 'float',
  },
  SchedulingConfigurationListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Scorecard: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    workspaceId: 'string',
    orgId: 'string',
    name: 'string',
    grouping: 'string',
    objectIds: 'list',
    dateRange: 'string',
    lookbackType: 'string',
    lookbackAmount: 'int',
    columnVisibility: 'string',
    columnOrder: 'list',
    sort: 'string',
    default: 'boolean',
  },
  ScorecardListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ScorecardMetricsRow: {
    bucket: 'string',
    period: 'string',
    leads: 'int',
    MQLs: 'int',
    appointments: 'int',
    patients: 'int',
    production: 'float',
    scheduledProduction: 'float',
    budget: 'float',
    totalSpend: 'float',
    ROI: 'float',
    CPL: 'float',
    CPQL: 'float',
    CPA: 'float',
    CAC: 'float',
    scheduleRate: 'float',
    leadsNeedsAction: 'int',
    leadsInProgress: 'int',
    leadsScheduled: 'int',
    leadsClosedWon: 'int',
    leadsClosedLost: 'int',
    subRows: 'list',
  },
  SendingDomain: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    domain: 'string',
    type: 'string',
    status: 'string',
    dnsRecords: 'list',
  },
  SendingDomainDnsRecord: {
    type: 'string',
    name: 'string',
    value: 'string',
    found: 'boolean',
  },
  SendingDomainListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  ShadowStats: {
    total: 'int',
    last24h: 'int',
    avgMatchScore: 'int',
    byWorkspace: 'list',
  },
  SikkaOffice: {
    id: 'string',
    name: 'string',
    practices: 'list',
  },
  SikkaPractice: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
  },
  SmsDailyCounts: {
    date: 'string',
    inbound: 'int',
    agentTexts: 'int',
    workflowTexts: 'int',
    staffTexts: 'int',
    otherTexts: 'int',
    staffReplyTakeovers: 'int',
    manualToggleTakeovers: 'int',
    optOutTakeovers: 'int',
    undeliveredTexts: 'int',
    carrierFailedTexts: 'int',
    noConsentTexts: 'int',
    quietHoursTexts: 'int',
    stuckPendingTexts: 'int',
    optOuts: 'int',
    aiReplyFailures: 'int',
  },
  SmsDailyMetricsResponse: {
    daily: 'list',
    locations: 'list',
  },
  SmsLocationCompareCounts: {
    locationId: 'string',
    aiConversations: 'int',
    takeovers: 'int',
    inboundThreads: 'int',
    unansweredThreads: 'int',
  },
  SmsLocationCounts: {
    locationId: 'string',
    locationName: 'string',
    workspaceId: 'string',
    workspaceName: 'string',
    lastAgentTextDate: 'string',
    inbound: 'int',
    outbound: 'int',
    agentTexts: 'int',
    workflowTexts: 'int',
    staffTexts: 'int',
    externalTexts: 'int',
    voiceAgentTexts: 'int',
    inboundThreads: 'int',
    unansweredThreads: 'int',
    aiConversations: 'int',
    repliedConversations: 'int',
    bookings: 'int',
    takeovers: 'int',
    staffReplyTakeovers: 'int',
    manualToggleTakeovers: 'int',
    optOutTakeovers: 'int',
    failedTexts: 'int',
    undeliveredTexts: 'int',
    carrierFailedTexts: 'int',
    noConsentTexts: 'int',
    quietHoursTexts: 'int',
    stuckPendingTexts: 'int',
    optOuts: 'int',
    aiTurns: 'int',
    toolErrorTurns: 'int',
    aiLatencyMsTotal: 'float',
    aiCostUsd: 'float',
    staffResponses: 'int',
    staffResponseMinutesTotal: 'float',
    aiReplyFailures: 'int',
  },
  SmsLocationDailyReplies: {
    locationId: 'string',
    lastAgentTextBeforeRange: 'string',
    days: 'list',
  },
  SmsLocationDayCount: {
    date: 'string',
    agentTexts: 'int',
  },
  SmsLocationMetricsResponse: {
    rows: 'list',
    total: 'object',
    compareRows: 'list',
    compareTotal: 'object',
  },
  SmsNumber: {
    phone: 'string',
    provider: 'string',
    label: 'string',
    registrationStatus: 'string',
  },
  SmsOpsMetrics: {
    totalInbound: 'int',
    unanswered: 'int',
    staffReplied: 'int',
    agentReplied: 'int',
    avgStaffReplyMinutes: 'float',
    avgAgentReplyMinutes: 'float',
    agentRepliedLate: 'int',
  },
  SmsStaffTakeoverCounts: {
    userId: 'string',
    userName: 'string',
    locationId: 'string',
    locationName: 'string',
    workspaceId: 'string',
    workspaceName: 'string',
    staffReplied: 'int',
    staffTurnedOff: 'int',
    total: 'int',
    lastTakeoverDate: 'string',
  },
  SmsStaffTakeoverResponse: {
    rows: 'list',
  },
  SmsTemplate: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    body: 'string',
  },
  SmsTemplateListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Staff: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    aliases: 'list',
    userId: 'string',
  },
  StaffBreakdownResponse: {
    hits: 'list',
  },
  StaffBreakdownRow: {
    bucket: 'string',
    id: 'string',
    date: 'string',
    isStaff: 'boolean',
    newPatientCalls: 'int',
    qualifiedNPCalls: 'int',
    disqualifiedNPCalls: 'int',
    scheduledNPCalls: 'int',
    unscheduledNPCalls: 'int',
    averageDuration: 'float',
    speedToLead: 'float',
    NPCallScheduleRate: 'float',
  },
  StaffConversionMetric: {
    userId: 'string',
    userName: 'string',
    leads: 'int',
    qualified: 'int',
    disqualified: 'int',
  },
  StaffListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  StaffResult: {
    id: 'string',
    name: 'string',
    aliases: 'list',
    userId: 'string',
    error: 'string',
    isDuplicated: 'boolean',
  },
  StaffSummary: {
    id: 'string',
    name: 'string',
    aliases: 'list',
    userId: 'string',
  },
  StoredCredential: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    label: 'string',
    username: 'string',
    metadata: 'string',
    createdBy: 'string',
    updatedBy: 'string',
  },
  StoredCredentialListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  StoredCredentialSecret: {
    id: 'string',
    password: 'string',
  },
  SuperNotificationSettings: {
    enabled: 'boolean',
    toolError: 'boolean',
    toolTimeout: 'boolean',
    toolDuplicate: 'boolean',
    noCallsIn48h: 'boolean',
    agentChangesEnabled: 'boolean',
    agentChangeOffers: 'boolean',
    agentChangeServices: 'boolean',
    agentChangeBusinessDetails: 'boolean',
    agentChangeAppointmentTypes: 'boolean',
  },
  SyncRun: {
    id: 'string',
    locationId: 'string',
    connectorType: 'string',
    entityType: 'string',
    startedAt: 'datetime',
    completedAt: 'datetime',
    success: 'boolean',
    errorMessage: 'string',
    recordsProcessed: 'int',
  },
  SyncRunConnection: {
    nodes: 'list',
    pageInfo: 'object',
  },
  TagColor: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    entity: 'string',
    isOrgTag: 'boolean',
    color: 'string',
    lastUsedDate: 'datetime',
  },
  TagColorListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Task: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    archived: 'boolean',
    dueDate: 'datetime',
    title: 'string',
    description: 'string',
    contactId: 'string',
    ownerId: 'string',
    roleId: 'string',
    createdById: 'string',
    completedByUserId: 'string',
    status: 'string',
  },
  TaskListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  TaskTemplate: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    name: 'string',
    title: 'string',
    description: 'string',
    dueInDays: 'int',
    ownerId: 'string',
  },
  TaskTemplateListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  TextMessagesNotificationSettings: {
    enabled: 'boolean',
    newTextMessage: 'object',
  },
  Thread: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    aiEnabled: 'boolean',
    name: 'string',
    phone: 'string',
    lastIncomingMessageDate: 'datetime',
    lastOutgoingMessageDate: 'datetime',
    agentBrief: 'string',
    activeWorkflowId: 'string',
    agentActivityId: 'string',
    agentBriefSetDate: 'datetime',
    agentLastMessageDate: 'datetime',
    agentReplyDueDate: 'datetime',
    nameSetAtDate: 'datetime',
    nameSetByUserId: 'string',
  },
  ThreadListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Transaction: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    patientId: 'string',
    transactionSrNo: 'string',
    providerId: 'string',
    sikkaOfficeId: 'string',
    amount: 'float',
    transactionType: 'string',
    transactionDate: 'datetime',
    procedureCode: 'string',
    treatmentCategory: 'string',
    procedureDescription: 'string',
    transactionEntryDate: 'datetime',
    type: 'string',
    vendor: 'string',
  },
  TransactionListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  TreatmentPlan: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    vendorId: 'string',
    vendor: 'string',
    patientId: 'string',
    displayName: 'string',
    status: 'string',
    state: 'string',
    procedureIds: 'list',
    procedureFeeOverrides: 'string',
    planCreateDate: 'datetime',
    planUpdateDate: 'datetime',
  },
  TreatmentPlanListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  TriggerPreviewConditionRejectType: {
    attribute: 'string',
    operator: 'string',
    value: 'string',
    rejectedCount: 'int',
  },
  TriggerPreviewMatchType: {
    sourceType: 'string',
    sourceId: 'string',
    eventId: 'string',
    contactId: 'string',
    date: 'datetime',
    conditionValues: 'string',
    reconstructedFromRecord: 'boolean',
  },
  TriggerPreviewResultType: {
    matches: 'list',
    total: 'int',
    page: 'int',
    examinedCount: 'int',
    conditionRejections: 'list',
    eventHistoryStart: 'datetime',
  },
  TriggerWorkflowOnContactResult: {
    success: 'boolean',
    workflowType: 'string',
    workflowId: 'string',
    contactId: 'string',
  },
  TwilioNumberConfig: {
    id: 'string',
    type: 'string',
    phone: 'string',
    sourceName: 'string',
    label: 'string',
    poolId: 'string',
    areaCode: 'string',
    poolSize: 'int',
    sessionDuration: 'int',
  },
  TwilioPhoneNumber: {
    id: 'string',
    name: 'string',
    isUsed: 'boolean',
  },
  UnmappedFormKey: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    rawKey: 'string',
    vendors: 'string',
  },
  UnmappedFormKeyListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  UsageCostBucket: {
    date: 'string',
    voiceCalls: 'int',
    smsConversations: 'int',
    voiceCostUsd: 'float',
    smsCostUsd: 'float',
    voiceMinutes: 'float',
    tokensInput: 'int',
    tokensOutput: 'int',
  },
  UsageCostCount: {
    key: 'string',
    count: 'int',
  },
  UsageCostLocation: {
    locationId: 'string',
    locationName: 'string',
    workspaceName: 'string',
    voiceCalls: 'int',
    smsConversations: 'int',
    totalCostUsd: 'float',
    voiceCostUsd: 'float',
    smsCostUsd: 'float',
    avgCostPerInteraction: 'float',
  },
  UsageCostResponse: {
    summary: 'object',
    buckets: 'list',
    locations: 'list',
    voiceOutcomes: 'list',
    voiceTransferredCalls: 'int',
    smsToolCalls: 'list',
    avgSmsLatencyMs: 'float',
  },
  UsageCostSmsThread: {
    threadId: 'string',
    contactId: 'string',
    turns: 'int',
    firstTurnDate: 'string',
    lastTurnDate: 'string',
    tokensInput: 'int',
    tokensOutput: 'int',
    llmCostUsd: 'float',
    carrierCostUsd: 'float',
    totalCostUsd: 'float',
    avgLatencyMs: 'float',
  },
  UsageCostSmsThreadListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  UsageCostSummary: {
    totalCostUsd: 'float',
    voiceCalls: 'int',
    smsConversations: 'int',
    voiceMinutes: 'float',
    totalTokensInput: 'int',
    totalTokensOutput: 'int',
    avgCostPerVoiceCall: 'float',
    avgCostPerSmsConversation: 'float',
    telephonyCostUsd: 'float',
    elevenLabsLlmUsd: 'float',
    elevenLabsPlatformUsd: 'float',
    elevenLabsTotalUsd: 'float',
    smsLlmCostUsd: 'float',
    smsCarrierCostUsd: 'float',
  },
  UsageCostVoiceCall: {
    callId: 'string',
    callDate: 'string',
    callerPhone: 'string',
    status: 'string',
    transferred: 'boolean',
    durationSeconds: 'int',
    telephonyCostUsd: 'float',
    elevenLabsAsrUsd: 'float',
    elevenLabsTtsUsd: 'float',
    elevenLabsLlmUsd: 'float',
    elevenLabsPlatformUsd: 'float',
    elevenLabsTotalUsd: 'float',
    llmInputTokens: 'int',
    llmOutputTokens: 'int',
    totalCostUsd: 'float',
  },
  UsageCostVoiceCallListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  User: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    email: 'string',
    name: 'string',
    aliases: 'list',
    jobTitle: 'string',
    position: 'string',
    phone: 'string',
    archived: 'boolean',
    type: 'string',
    role: 'int',
    roleId: 'string',
    permissions: 'list',
    isOrgRole: 'boolean',
    assignedWorkspaceIds: 'list',
    allowedLocationIds: 'list',
    assignedLocationIds: 'list',
    workspaces: 'list',
    lastLoginDate: 'datetime',
    preferredChannel: 'string',
    timezone: 'string',
    roleName: 'string',
    products: 'list',
  },
  UserActivityEntry: {
    action: 'string',
    dateTime: 'string',
    email: 'string',
    role: 'string',
  },
  UserActivityResult: {
    activities: 'list',
  },
  UserListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  UserNotificationSettings: {
    phoneCalls: 'object',
    aiAgent: 'object',
    textMessages: 'object',
    formSubmissions: 'object',
    scheduler: 'object',
    pmsData: 'object',
    workflowPaused: 'object',
  },
  UserSetting: {
    userId: 'string',
    key: 'string',
    value: 'string',
  },
  UtmAlias: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    type: 'string',
    original: 'string',
    alias: 'string',
  },
  UtmAliasListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  VoiceAgentDailyCounts: {
    date: 'string',
    aiCalls: 'int',
    failedCalls: 'int',
    gptFailedCalls: 'int',
    elevenLabsFailedCalls: 'int',
  },
  VoiceAgentDailyMetricsResponse: {
    daily: 'list',
    locations: 'list',
  },
  VoiceAgentLocationCounts: {
    locationId: 'string',
    locationName: 'string',
    workspaceId: 'string',
    workspaceName: 'string',
    aiCalls: 'int',
    newPatientCalls: 'int',
    appointmentsBooked: 'int',
    appointmentsCompleted: 'int',
    toolErrorCalls: 'int',
    toolTimeoutCalls: 'int',
    toolDuplicateCalls: 'int',
    failedCalls: 'int',
    llmFailedCalls: 'int',
    llmSlowCalls: 'int',
    disconnectedCalls: 'int',
    maxDurationCalls: 'int',
    errorCalls: 'int',
    unsuccessfulCalls: 'int',
    gptFailedCalls: 'int',
    elevenLabsFailedCalls: 'int',
  },
  VoiceAgentLocationDailyCalls: {
    locationId: 'string',
    lastCallBeforeRange: 'string',
    days: 'list',
  },
  VoiceAgentLocationDayCount: {
    date: 'string',
    aiCalls: 'int',
  },
  VoiceAgentLocationMetricsResponse: {
    rows: 'list',
    total: 'object',
    compareRows: 'list',
    compareTotal: 'object',
  },
  VoiceAgentMetricsResponse: {
    scheduleRate: 'float',
    newPatientCalls: 'int',
    appointmentsBooked: 'int',
    appointmentsCompleted: 'int',
    totalCalls: 'int',
    locationCount: 'int',
  },
  Workflow: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    name: 'string',
    active: 'boolean',
    paused: 'boolean',
    pausedReason: 'string',
    pausedNodeId: 'string',
    pausedDate: 'datetime',
    triggerJson: 'string',
    nodesJson: 'string',
    edgesJson: 'string',
    settingsJson: 'string',
    builderJson: 'string',
    category: 'string',
    triggerStartDate: 'datetime',
  },
  WorkflowDateTriggerField: {
    sourceType: 'string',
    attribute: 'string',
    storage: 'string',
  },
  WorkflowListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  WorkflowPausedNotificationSettings: {
    enabled: 'boolean',
    email: 'boolean',
    app: 'boolean',
  },
  WorkflowRun: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    locationId: 'string',
    workflowId: 'string',
    contactId: 'string',
    activityId: 'string',
    parentRunId: 'string',
    branchTaskId: 'string',
    status: 'string',
    currentNodeId: 'string',
    resumeAt: 'datetime',
    waitingFor: 'string',
    startedAt: 'datetime',
    exitReason: 'string',
    enrollmentEventId: 'string',
    sourceType: 'string',
    sourceId: 'string',
    enrolledByUserId: 'string',
    sentPaperworkId: 'string',
  },
  WorkflowRunEvent: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    runId: 'string',
    workflowId: 'string',
    eventId: 'string',
    contactId: 'string',
    nodeId: 'string',
    nodeType: 'string',
    status: 'string',
    timestamp: 'datetime',
    outputJson: 'string',
  },
  WorkflowRunEventListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  WorkflowRunListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  Workspace: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    name: 'string',
    orgId: 'string',
    orgTags: 'list',
    carestackId: 'string',
    ascendOrgId: 'string',
    lastPmsSyncDate: 'datetime',
    lastFacebookLeadsErrorDate: 'datetime',
    marketingConsentConfirmedDate: 'datetime',
    marketingConsentConfirmedByUserId: 'string',
    promptAddendum: 'string',
    gravityFormsMultiConfig: 'object',
    archived: 'boolean',
    emailSendingPaused: 'boolean',
    maxOutboundMonthly: 'float',
    maxOutboundDaily: 'float',
    maxEnrollmentsPerHour: 'float',
  },
  WorkspaceInvite: {
    version: 'int',
    createdDate: 'datetime',
    updatedDate: 'datetime',
    id: 'string',
    orgId: 'string',
    workspaceId: 'string',
    userId: 'string',
    staffId: 'string',
    email: 'string',
    roleId: 'string',
    locationIds: 'list',
    invitedBy: 'string',
    code: 'string',
    createdAt: 'datetime',
    expiresAt: 'datetime',
  },
  WorkspaceInviteListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  WorkspaceListResult: {
    hits: 'list',
    total: 'int',
    page: 'int',
  },
  WorkspaceStat: {
    name: 'string',
    total: 'int',
  },
}
